import { html, slotted, ref } from "@microsoft/fast-element";
import { whitespaceFilter } from "../../util/whitespace-filter.js";
import { searchIcon, dismissIcon } from "../../static/component-svgs.js";
/**
 * The template for the {@link @fabric-msft/fabric-web#(SearchBox:class)} component.
 * @public
 */
export function searchBoxTemplate() {
    return html `
    <template
      @beforeinput="${(x, c) => x.beforeinputHandler(c.event)}"
      @focusin="${(x, c) => x.focusinHandler(c.event)}"
      @keydown="${(x, c) => x.keydownHandler(c.event)}"
    >
      <label for="control" class="label" ${ref("controlLabel")}>
        <slot
          ${slotted({
        property: "defaultSlottedNodes",
        filter: whitespaceFilter
    })}
        ></slot>
      </label>
      <span class="root">
        <span class="search-icon">${searchIcon}</span>
        <input
          aria-label="${(x) => x.ariaLabel}"
          class="control"
          id="control"
          @change="${(x, c) => x.changeHandler(c.event)}"
          @input="${(x, c) => x.inputHandler(c.event)}"
          ?autofocus="${(x) => x.autofocus}"
          autocomplete="${(x) => x.autocomplete}"
          ?disabled="${(x) => x.disabled}"
          list="${(x) => x.list}"
          maxlength="${(x) => x.maxlength}"
          minlength="${(x) => x.minlength}"
          ?multiple="${(x) => x.multiple}"
          name="${(x) => x.name}"
          pattern="${(x) => x.pattern}"
          placeholder="${(x) => x.placeholder}"
          ?readonly="${(x) => x.readOnly}"
          ?required="${(x) => x.required}"
          size="${(x) => x.size}"
          spellcheck="${(x) => x.spellcheck}"
          type="${(x) => x.type}"
          value="${(x) => x.initialValue}"
          ${ref("control")}
        />
        <fabric-button
          aria-label="clear"
          appearance="transparent"
          class="clear-button"
          aria-hidden="true"
          ${ref("clearButton")}
          @click="${(x) => x.clear()}"
        >
          ${dismissIcon}
        </fabric-button>
        <slot name="end"></slot>
      </span>
    </template>
  `;
}
export const template = searchBoxTemplate();
//# sourceMappingURL=search-box.template.js.map